import type { Question } from '@/models/question';

import { topics } from './topics';

const questionPatterns = [
  (focus: string): string => `A prefeitura deve ampliar ${focus}?`,
  (focus: string): string => `Deve investir mais em ${focus}?`,
  (focus: string): string => `Deve criar metas públicas para ${focus}?`,
  (focus: string): string => `Deve ampliar o acesso a ${focus} nos bairros com maior demanda?`,
  (focus: string): string => `Deve priorizar ${focus} no próximo orçamento?`,
  (focus: string): string => `Deve publicar relatórios periódicos sobre ${focus}?`,
  (focus: string): string => `Deve integrar ações de ${focus} com outras políticas públicas?`,
  (focus: string): string => `Deve reforçar as ações de curto prazo para ${focus}?`,
] as const;

function createQuestionsForTopic(topicId: string): Question[] {
  const topic = topics.find((entry) => entry.id === topicId);

  if (!topic) {
    return [];
  }

  return questionPatterns.map((createText, index) => ({
    id: `${topic.id}-q${index + 1}`,
    topicId: topic.id,
    text: createText(topic.questionFocus),
    positionStatements: topic.positionStatements,
  }));
}

export const questions: Question[] = topics.flatMap((topic) => createQuestionsForTopic(topic.id));

export const questionsByTopicId = topics.reduce<Record<string, Question[]>>((accumulator, topic) => {
  accumulator[topic.id] = createQuestionsForTopic(topic.id);
  return accumulator;
}, {});
